module.exports = __webpack_public_path__ + "resources/img/main02_jp.e573581631614110443a733ef9d421a6.jpg";